import React, { useEffect, useState } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import Home from "./pages/Home.js";
import Wazaren from "./pages/Wazaren.js";
import WazarenDetails from "./pages/WazarenDetails.js";
import Wotageishi from "./pages/Wotageishi.js";
import WotageishiDetails from "./pages/WotageishiDetails.js";
import Organization from "./pages/Organization.js";
import OrganizationDetails from "./pages/OrganizationDetails.js";
import Movement from "./pages/Movement.js";
import Place from "./pages/Place.js";
import PlaceDetails from "./pages/PlaceDetails.js";
import NotFound from "./pages/NotFound.js";
import RequestTopic from './pages/RequestTopic.js';
import WazarenNewRequest from './pages/WazarenNewRequest';
import WotageishiNewRequest from './pages/WotageishiNewRequest.js';
import OrganizationNewRequest from './pages/OrganizationNewRequest.js';
import WazarenUpdateRequest from './pages/WazarenUpdateRequest.js';
import WotageishiUpdateRequest from './pages/WotageishiUpdateRequest.js';
import OrganizationUpdateRequest from './pages/OrganizationUpdateRequest.js';
import ApproveTopic from './pages/ApproveTopic';
import WazarenApprove from './pages/WazarenApprove';
import WazarenApprovePreview from './pages/WazarenApprovePreview';
import WotageishiApprove from './pages/WotageishiApprove';
import WotageishiApprovePreview from './pages/WotageishiApprovePreview.js';
import OrganizationApprove from './pages/OrganizationApprove';
import OrganizationApprovePreview from './pages/OrganizationApprovePreview.js';
import UserProfile from './pages/UserProfile.js';
import UserSetting from './pages/UserSetting.js';
import VerifyEmail from './pages/VerifyEmail.js';
import ResetPassword from './pages/ResetPassword.js';
import TermsExplained from './pages/TermsExplained.js';
import ContactUs from './pages/ContactUs.js';
import * as CONSTANTS from "./constants" ;
import { ThemeProvider } from './styles/ThemeContext.js';

 
function App() {

    return (
        <ThemeProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to={`/${CONSTANTS.LANGUAGE_ABBR.TRADITIONAL_CHINESE}/home/`} replace />} />
                <Route path="/:lang" element={<Navigate to={`./home/`} relative />} />
                <Route path={`/`} element={<Home />}/>
                {/* Home */}
                <Route path={`/:lang/home/`} element={<Home />} />
                {/* Wazaren */}
                <Route path={`/:lang/wazaren/`} element={<Wazaren />} />
                <Route path={`/:lang/wazarens/:wazarenId/`} element={<WazarenDetails />}/>
                {/* Wotageishi */}
                <Route path={`/:lang/wotageishi/`} element={<Wotageishi />} />
                <Route path={`/:lang/wotageishis/:wotageishiId/`} element={<WotageishiDetails />}/>
                {/* Organization */}
                <Route path={`/:lang/organization/`} element={<Organization />} />
                <Route path={`/:lang/organizations/:organizationId/`} element={<OrganizationDetails />}/>
                {/* Movement */}
                <Route path={`/:lang/movement/`} element={<Movement />} />
                {/* Place */}
                <Route path={`/:lang/place/`} element={<Place />} />
                <Route path={`/:lang/places/:placeId/`} element={<PlaceDetails />}/>
                {/* Request Topic */}
                <Route path={`/:lang/request-topic/`} element={<RequestTopic />} />
                {/* Request Topic: NEW */}
                <Route path={`/:lang/request-topic/wazaren/new/`} element={<WazarenNewRequest />} />
                <Route path={`/:lang/request-topic/wotageishi/new/`} element={<WotageishiNewRequest />} />
                <Route path={`/:lang/request-topic/organization/new/`} element={<OrganizationNewRequest />} />
                {/* Request Topic: UPDATE */}
                <Route path={`/:lang/request-topic/wazaren/update/`} element={<WazarenUpdateRequest />} />
                <Route path={`/:lang/request-topic/wotageishi/update/`} element={<WotageishiUpdateRequest />} />
                <Route path={`/:lang/request-topic/organization/update/`} element={<OrganizationUpdateRequest />} />
                {/* Approve Topic */}
                <Route path={`/:lang/approve-topic/`} element={<ApproveTopic />} />
                <Route path={`/:lang/approve-topic/wazaren/`} element={<WazarenApprove />} />
                <Route path={`/:lang/approve-topic/wazaren/preview/:temp_id`} element={<WazarenApprovePreview />} />
                <Route path={`/:lang/approve-topic/wotageishi/`} element={<WotageishiApprove />} />
                <Route path={`/:lang/approve-topic/wotageishi/preview/:temp_id`} element={<WotageishiApprovePreview />} />
                <Route path={`/:lang/approve-topic/organization/`} element={<OrganizationApprove />} />
                <Route path={`/:lang/approve-topic/organization/preview/:temp_id`} element={<OrganizationApprovePreview />} />
                {/* User */}
                <Route path={`/:lang/user-profile/`} element={<UserProfile />} />
                <Route path={`/:lang/user-setting/`} element={<UserSetting />} />
                {/* User Verify */}
                <Route path={`/:lang/verify-email/:token`} element={<VerifyEmail />} />
                <Route path={'/:lang/reset-password'} element={<ResetPassword />} />
                {/* Terms Explained */}
                <Route path={'/:lang/terms-explained'} element={<TermsExplained />} />
                {/* Contact Us */}
                <Route path={'/:lang/contact-us'} element={<ContactUs />} />
                {/* Not Found */}
                <Route path={`/:lang/*`} element={<NotFound />}/>

            </Routes>
        </BrowserRouter>
        </ThemeProvider>
    );
}
 
export default App;